(function ($) {
  'use strict';

  /**
   * Regional Site Picker
   */

  var $regional_site_select = $('#regional-sites');

  $regional_site_select.on('change', function () {
    var regional_url = $(this).val();
    if ( regional_url !== '' ) {
      window.location = regional_url;
    }
    return false;
  });

})(jQuery);
